import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewUserCounter } from 'app/shared/models/class/counter/counter';
import { CustomerDetails, SocialUserSignUp, UserSignUp } from 'app/shared/models/class/user/user';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private userCurrent!: CustomerDetails;
  usercurrent$ = new Subject<CustomerDetails>();

  constructor(private readonly http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getUserDetails(userKey: number): Observable<CustomerDetails> {
    return this.http.get<CustomerDetails>(`${environment.apiUrl}/users/${userKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  signup(newUser: SocialUserSignUp): Observable<UserSignUp> {
    return this.http.post<UserSignUp>(`${environment.apiUrl}/users`, newUser);
  }

  signByMail(newUser: any): Observable<UserSignUp> {
    return this.http.post<UserSignUp>(`${environment.apiUrl}/users/UserByMail`, newUser);
  }

  changePassword() {
    return this.http.post(`${environment.apiUrl}/users/password`, null);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateUser(user: NewUserCounter) {
    return this.http.put(`${environment.apiUrl}/users/updateUser`, user);
  }

  setUser(user: any): void { this.userCurrent = user; }
  getUser(): CustomerDetails { return this.userCurrent; }

}
